module.exports = __webpack_public_path__ + "static/img/rain1.28a247f8.png";